import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import 'bootstrap/dist/css/bootstrap.min.css';
import Loading from '@spark/ui-components/components/Loading';
import Router from './Router';
import ChatIaGlobal from '../ChatIa/ChatIaGlobal';
import ScrollToTop from './ScrollToTop';
import GlobalStyles from './globalStyles';
import NotificationStyles from './notificationStyles';
import { AuthProvider } from '@/context/AuthContext';
import { NotificacoesAlertProvider } from '@/context/NotificacoesAlertContext';
import { getOidcConfig } from '@/config/cognito';
import { cleanupOldAuthData } from '@/utils/cleanup';

const App = () => {
  const [isLoading, setIsLoading] = useState(false); // Bug loading infinito, retirei pra conseguir logar...
  const [isLoaded, setIsLoaded] = useState(false);

  // Cleanup de dados obsoletos de autenticação (executa apenas uma vez)
  useEffect(() => {
    cleanupOldAuthData();
  }, []);

  useEffect(() => {
    let hasFinished = false;

    const finishLoading = () => {
      if (hasFinished) return;
      hasFinished = true;
      setIsLoading(false);
      setTimeout(() => setIsLoaded(true), 500);
    };

    const fallbackTimeout = setTimeout(finishLoading, 2000);

    if (document.readyState === 'complete') {
      finishLoading();
    } else {
      window.addEventListener('load', finishLoading);
    }

    return () => {
      window.removeEventListener('load', finishLoading);
      clearTimeout(fallbackTimeout);
    };
  }, []);

  const oidcConfig = getOidcConfig();

  return (
    <BrowserRouter>
      <OidcAuthProvider {...oidcConfig}>
        <AuthProvider>
          <NotificacoesAlertProvider>
            <ScrollToTop>
              {!isLoaded && isLoading && <Loading />}
              <ThemeProvider theme={{
                mode: 'light',
                direction: 'ltr'
              }}>
                <NotificationStyles />
                <GlobalStyles />
                <Router />
                <ChatIaGlobal />
              </ThemeProvider>
            </ScrollToTop>
          </NotificacoesAlertProvider>
        </AuthProvider>
      </OidcAuthProvider>
    </BrowserRouter>
  );
};

export default App;
